/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  GetPsrServicesByVulnerabilityIdsParams,
  PaperBillStateResponse,
  PsrCustomerSettings,
  PsrCustomerSettingsResponse,
  ServicesResponse,
  VulnerabilityCategoriesResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get PSR paper-bill eligibility, the selected paper-bill type, and the reserved paper-bill contact emails (used by the FE to lock contacts that must not be edited)
 */
export const getPaperBillState = (
  billingAccountId: number,
  options?: SecondParameter<typeof backofficeRequest<PaperBillStateResponse>>,
) => {
  return backofficeRequest<PaperBillStateResponse>(
    { url: `/accounts/${billingAccountId}/paper-bill-state`, method: "GET" },
    options,
  )
}
/**
 * @summary Store PSR customer vulnerabilities and selected services
 */
export const storeVulnerabilitiesAndAssociatedServices = (
  customerId: number,
  psrCustomerSettings: PsrCustomerSettings,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/api/v1/customers/${customerId}/psr`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: psrCustomerSettings,
    },
    options,
  )
}
/**
 * @summary Fetch PSR customer vulnerabilities and selected services for the given customer
 */
export const getPsrCustomerSettings = (
  customerId: number,
  options?: SecondParameter<
    typeof backofficeRequest<PsrCustomerSettingsResponse>
  >,
) => {
  return backofficeRequest<PsrCustomerSettingsResponse>(
    { url: `/api/v1/customers/${customerId}/psr`, method: "GET" },
    options,
  )
}
/**
 * @summary Get Psr Vulnerability categories
 */
export const getPsrVulnerabilityCategories = (
  options?: SecondParameter<
    typeof backofficeRequest<VulnerabilityCategoriesResponse[]>
  >,
) => {
  return backofficeRequest<VulnerabilityCategoriesResponse[]>(
    { url: `/api/v1/psr/categories`, method: "GET" },
    options,
  )
}
/**
 * @summary Get Services for Vulnerability IDs
 */
export const getPsrServicesByVulnerabilityIds = (
  params: GetPsrServicesByVulnerabilityIdsParams,
  options?: SecondParameter<typeof backofficeRequest<ServicesResponse[]>>,
) => {
  return backofficeRequest<ServicesResponse[]>(
    { url: `/api/v1/psr/services`, method: "GET", params },
    options,
  )
}
export type GetPaperBillStateResult = NonNullable<
  Awaited<ReturnType<typeof getPaperBillState>>
>
export type StoreVulnerabilitiesAndAssociatedServicesResult = NonNullable<
  Awaited<ReturnType<typeof storeVulnerabilitiesAndAssociatedServices>>
>
export type GetPsrCustomerSettingsResult = NonNullable<
  Awaited<ReturnType<typeof getPsrCustomerSettings>>
>
export type GetPsrVulnerabilityCategoriesResult = NonNullable<
  Awaited<ReturnType<typeof getPsrVulnerabilityCategories>>
>
export type GetPsrServicesByVulnerabilityIdsResult = NonNullable<
  Awaited<ReturnType<typeof getPsrServicesByVulnerabilityIds>>
>
